import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { CreateDocumentRequest } from './CreateDocumentRequest';
import { PersistedAnswers } from './PersistedAnswers';
import { AnswerMap } from '../AnswerMap';


export default class DocumentResource extends FBaseService {
  public async createDocument(fiId: string, request: CreateDocumentRequest): Promise<PersistedAnswers> {
    const url = `/api/document/${fiId}`;

    const response: AxiosResponse = await this.apiClient.post(url, request);
    return response.data.data;
  }

  public async getPreview(fiId: string, answers: AnswerMap, debug: boolean): Promise<string> {
    const url = `/api/document/${fiId}/preview?debug=${debug}`;
    const response: AxiosResponse = await this.apiClient.post(url, answers);
    return response.data.data;
  }
}
